import React, { useContext } from 'react';
import { IFrame as Iframe, TmoCard } from '@tmobile/tmo-bps-syncup-web-component-lib';

import config from '../../../configs/config';
import SyncUpProductContext from '../../../context/SyncUpProductContext';

const {
  iframeDevicesPetsURL,
  iframeDevicesTrackerURL,
  iframeDevicesWatchURL
} = config.powerBiSettings;

function Devices() {
  const syncUpProductContext = useContext(SyncUpProductContext);
  const iframe = () => {
    switch (syncUpProductContext.syncUpAppName) {
      case 'TRACKER':
        return iframeDevicesTrackerURL;
      case 'KIDSWATCH':
        return iframeDevicesWatchURL;
      default:
        return iframeDevicesPetsURL;
    }
  };

  return (
    <TmoCard>
      <Iframe src={iframe()} width="100%" height="836px" />
    </TmoCard>
  );
}

export default Devices;
